import { render, staticRenderFns } from "./EditNomUser.vue?vue&type=template&id=33f9e775&scoped=true&"
import script from "./EditNomUser.ts?vue&type=script&lang=ts&"
export * from "./EditNomUser.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33f9e775",
  null
  
)

export default component.exports
import {QForm,QInput,QToggle,QBtn,QDialog,QCard,QCardSection} from 'quasar'
component.options.components = Object.assign({QForm,QInput,QToggle,QBtn,QDialog,QCard,QCardSection}, component.options.components || {})
